import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Phosphor's X bold variant (not available in @mds/icons)
 */
export default function DeleteIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 256 256" {...props}>
      <path d="M208.49 191.51a12 12 0 0 1-17 17L128 145l-63.51 63.49a12 12 0 0 1-17-17L111 128 47.51 64.49a12 12 0 0 1 17-17L128 111l63.51-63.52a12 12 0 0 1 17 17L145 128Z" />
    </SvgIcon>
  );
}
